/* eslint-disable */
import { produce } from "immer";
import {
  TOTAL_POTINFO_FETCH_FAILURE,
  TOTAL_POTINFO_FETCH_SUCCESS,
  TOTAL_POTINFO_FETCH_START,
} from "../actions/types";

const totalPotInfoReducer = (
  state = {
    fetching: false,
    potData: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case TOTAL_POTINFO_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case TOTAL_POTINFO_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.potData = action.potData;
        draft.fetching = false;
      });
    case TOTAL_POTINFO_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default totalPotInfoReducer;
